import {Directive, ElementRef, OnInit, HostListener, OnChanges, SimpleChanges, Input} from '@angular/core';

@Directive({
    selector: '[setHeight]'
})

export class MultiLineSelectHeightDirective implements OnInit, OnChanges {
    @Input() subscriptions: any[];
    constructor(private elementRef: ElementRef) {}

    ngOnInit(): void {
      setTimeout(() => {this.heightControl()});
    }

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['subscriptions'] && !changes['subscriptions'].firstChange) {
        setTimeout(() => {this.heightControl()});
      }
    }


    @HostListener('change') onChange() {
      setTimeout(() => {this.heightControl()});
    }

    public heightControl() {
      const elem = this.elementRef.nativeElement;
      elem.style.height = 'auto';

      if (elem.offsetHeight < elem.scrollHeight) {
        elem.style.height = elem.scrollHeight + 16 + 'px';
      }
    }
}
